import { useCallback } from 'react';
import { useHistory, useLocation } from 'react-router';
import '../constants/authorizedUsers.js';
import '../constants/bidStatus.js';
import '../constants/bulkLoadCardStatus.js';
import '../constants/misc.js';
import '../constants/event-names.js';
import '../constants/eventsMapObj.js';
import '../constants/Faq.js';
import '../constants/languages.js';
import '../constants/loadStatus.js';
import '../constants/lorryStatus.js';
import '../constants/lorryTypes.js';
import '../constants/mostSearchedLinks.js';
import '../constants/Pages.js';
import '../constants/serviceTypeId.js';
import '../constants/StateList.js';
import '../constants/bidUpdateType.js';
import '../constants/userAction.js';
import '../constants/api.js';
import '../constants/link.js';
import '../constants/market.js';
import '../constants/payment.js';
import '../constants/admin/screenId.js';
import '../_services/const.js';
import 'bowser';
import '../_virtual/_tslib.js';
import '../components/toast/toast.js';
import '../_services/auth.service.js';
import { updateNestedObject } from '../methods/updateNestedObject.js';
import '../methods/getAuthIdParam.js';
import 'react-cookie';
import '../methods/formatDate.js';
import '../methods/getTransporterFigure.js';
import '../methods/getDownloadsFigure.js';
import 'lodash.isequal';
import '../methods/getPageLoadSourceUTMParam.js';
import 'crypto-js';

function useHandleModalToggle(statePathArr) {
    const history = useHistory();
    const location = useLocation();
    const { state } = location;
    const openModal = useCallback(() => {
        history.push({
            pathname: history.location.pathname,
            search: history.location.search,
            hash: history.location.hash,
            state: updateNestedObject(state, statePathArr, true)
        });
    }, [history]);
    const closeModal = useCallback(() => {
        history.replace({
            pathname: history.location.pathname,
            search: history.location.search,
            hash: history.location.hash,
            state: updateNestedObject(state, statePathArr, undefined)
        });
    }, [history]);
    return { openModal, closeModal };
}

export { useHandleModalToggle };
//# sourceMappingURL=useHandleModalToggle.js.map
